<p-panel [ngClass]="{'readonly-texte': !editMode}">

	<ng-template pTemplate="header">
		<div class="flex align-items-center flex-wrap gap-2">
			<!-- Titre -->
			<div class="page-title-no-margin">
				{{
					isCreation ? ('textes.new_text' | translate)
					: pristineTexte.txt_reference
				}}
			</div>

			<!-- Coche actif/inactif -->
			<div class="field-checkbox mb-0">
				<p-checkbox
					name="txt_actif"
					inputId="txt_actif"
					[(ngModel)]="texte.txt_actif"
					[binary]="true"
					[label]="'textes.active_state' | translate"
					[disabled]="!editMode"
				></p-checkbox>
			</div>

			<!-- Coche modification majeure -->
			<div *ngIf="!texte.txt_brouillon" class="field-checkbox mb-0">
				<p-checkbox
					name="txt_modification_majeure"
					[(ngModel)]="texte.txt_modification_majeure"
					[binary]="true"
					label="{{'textes.major_modification_label' | translate}}"
					[disabled]="!editMode"
				></p-checkbox>
			</div>

		</div>
	</ng-template>

	<ng-template pTemplate="icons">
		<div class="flex flex-wrap gap-2">
			<!-- Bouton éditer -->
			<button
				*ngIf="!editMode && canEdit"
				type="button"
				pButton
				class="label-md-none"
				[label]="'common.edition_button_label' | translate"
				icon="pi pi-pencil"
				(click)="toggleEditMode()"
			></button>

			<!-- Bouton enregistrer -->
			<button
				*ngIf="!!editMode"
				type="button"
				pButton
				class="label-md-none"
				[label]="'common.save_button_label' | translate"
				icon="pi pi-save"
				(click)="submit()"
				[disabled]="!textForm.valid || texte.articles.length == 0"
			></button>

			<!-- Bouton enregistrer + publier -->
			<button
				*ngIf="isCreation && !!editMode"
				type="button"
				pButton
				class="label-md-none"
				[label]="'textes.save_and_publish_button_label' | translate"
				icon="pi pi-file-check"
				(click)="submit({publish: true})"
				[disabled]="!textForm.valid || texte.articles.length == 0 || texte.rubriques.length == 0"
			></button>

			<!-- Bouton publier -->
			<button
				*ngIf="!isCreation && canEdit && texte.txt_brouillon"
				type="button"
				pButton
				class="label-md-none"
				[label]="'textes.publish_button_label' | translate"
				icon="pi pi-file-check"
				(click)="publish()"
				[disabled]="editMode || (!texte.txt_exclusivement_modificatif && texte.rubriques.length == 0)"
			></button>

			<!-- Bouton historique -->
				<button
				*ngIf="!isCreation"
				type="button"
				pButton
				class="label-md-none"
				[label]="'common.history_button_label' | translate"
				icon="pi pi-book"
				(click)="showHistoryDialog()"
			></button>

			<!-- Bouton textes modifiés -->
			<button
				*ngIf="texte.textes_modifies.length > 0"
				type="button"
				pButton
				class="label-md-none"
				[label]="'textes.targeted_textes_button_label' | translate"
				icon="pi pi-link"
				(click)="showTargetedTextesList()"
			></button>

			<!-- Bouton textes modificatifs -->
			<button
				*ngIf="texte.textes_modificatifs.length > 0"
				type="button"
				pButton
				class="label-md-none"
				[label]="'textes.modifying_textes_button_label' | translate"
				icon="pi pi-link"
				(click)="showModifyingTextesList()"
			></button>
		</div>
	</ng-template>

	<form class="p-fluid grid formgrid p-1" #textForm="ngForm">
		<ng-container>
			<!-- Référence -->
			<div class="field col-12 md:col-6 xl:col-4">
				<label for="txt_reference">
					{{ 'textes.reference_label' | translate }}
					<ng-container *ngIf="showReferenceDuplicationWarning">
						<span class="font-bold ml-5">
							<i class="pi pi-exclamation-triangle"></i>
							{{ 'textes.reference_already_used' | translate }}
						</span>
					</ng-container>
				</label>

				<input
					type="text"
					pInputText
					name="txt_reference"
					[(ngModel)]="texte.txt_reference"
					(onDebounce)="onReferenceChange()"
					[debounce]="300"
					[readonly]="!editMode"
					placeholder="{{'textes.reference_label' | translate}}"
					required
				>
			</div>

			<!-- Edition -->
			<div class="field col-12 md:col-6 xl:col-4">
				<label for="txt_edition">
					{{ 'textes.edition_label' | translate }}
				</label>

				<input
					type="text"
					pInputText
					name="txt_edition"
					[(ngModel)]="texte.txt_edition"
					[readonly]="!editMode"
					placeholder="{{'textes.edition_label' | translate}}"
				>
			</div>

			<div class="col-12"></div>

			<!-- URL -->
			<div class="field col-12">
				<label for="txt_url">
					{{ 'textes.link_label' | translate }}
				</label>

				<div *ngIf="!editMode">
					<a href="{{texte.txt_url}}" class="text-blue-500">
						{{texte.txt_url}}
					</a>
				</div>

				<input
					*ngIf="editMode"
					type="text"
					pInputText
					name="txt_url"
					[(ngModel)]="texte.txt_url"
					placeholder="{{'textes.link_label' | translate}}"
				>
			</div>

			<!-- Rubriques -->
			<div class="field col-12 mb-4">
				<label for="txt_edition">
					{{ 'textes.rubriques_label' | translate }}
				</label>

				<!-- Bouton d'ajout -->
				<button
					*ngIf="editMode && !texte.txt_exclusivement_modificatif"
					type="button"
					pButton
					class="p-button-rounded p-button-text"
					icon="pi pi-plus"
					(click)="showRubriqueAdditionDialog()"
				></button>

				<div class="rubriques-list mb-2" [ngClass]="{'clickable': texte.rubriques.length > 1 && !rubriquesExpanded}" #rubriques (click)="expandRubriques($event)">

					<!-- Rubriques -->
					<p-card *ngFor="let rubrique of texte.rubriques">
						<div class="flex flex-row align-items-center justify-content-between">
							<span>{{rubrique|nomenclature}}</span>

							<div *ngIf="editMode" class="flex flex-row align-items-center">
								<button
									type="button"
									pButton
									icon="pi pi-times-circle"
									class="p-button-rounded p-button-text p-button-danger"
									(click)="removeRubrique(rubrique)"
								></button>
							</div>
						</div>
					</p-card>

					<!-- Message si aucune rubrique -->
					<div *ngIf="texte.rubriques.length == 0">
						{{
							(texte.txt_exclusivement_modificatif ? 
							'textes.rubrique_restriction_explanation'
							: 'textes.texte_linked_to_no_rubrique') | translate
						}}
					</div>
				</div>

				<button
						*ngIf="texte.rubriques.length > 1"
						type="button"
						pButton
						class="p-button-rounded p-button-text w-max block"
						icon="p-button-icon-left pi {{ rubriquesExpanded? 'pi-arrow-down-left-and-arrow-up-right-to-center' : 'pi-arrow-up-right-and-arrow-down-left-from-center' }}"
						[label]="( rubriquesExpanded? 'textes.collapse_rubriques' : 'textes.show_all_rubriques' )| translate"
						(click)="rubriquesExpanded? collapseRubriques($event) : expandRubriques($event)"
					>
					</button>
			</div>

			<div class="col-12"></div>

			<!-- Date signature -->
			<div class="field col-12 md:col-6 xl:col-3">
				<label for="txt_date_signature">
					{{ 'textes.signature_date_label' | translate }}
				</label>

				<input
					*ngIf="!editMode"
					[ngClass]="{inactive: !texte.txt_date_signature}"
					type="text"
					pInputText
					[attr.value]="texte.txt_date_signature | date:'shortDate'"
					[readonly]="true"
				>

				<p-calendar
					*ngIf="editMode"
					name="txt_date_signature"
					[(ngModel)]="texte.txt_date_signature"
					dateFormat="dd/mm/yy"
					[firstDayOfWeek]="1"
					view="date"
					yearRange="1900:2100"
					[showIcon]="true"
					placeholder="{{'textes.signature_date_label' | translate}}"
				></p-calendar>
			</div>

			<div class="col-12"></div>

			<!-- Date abrogation -->
			<div class="field col-12 md:col-6 xl:col-3">
				<label for="txt_date_abrogation">
					{{ 'textes.abrogation_date_label' | translate }}
				</label>

				<input
					*ngIf="!editMode"
					[ngClass]="{inactive: !texte.txt_date_abrogation}"
					type="text"
					pInputText
					[attr.value]="texte.txt_date_abrogation | date:'shortDate'"
					[readonly]="true"
				>

				<!-- Si la case abrogé vient d'être cochée on demande à fournir une date et que celle-ci soit dans le passé ou aujourd'hui -->
				<p-calendar
					*ngIf="editMode"
					name="txt_date_abrogation"
					[(ngModel)]="texte.txt_date_abrogation"
					(ngModelChange)="onDateAbrogationChange()"
					dateFormat="dd/mm/yy"
					[maxDate]="(texte.txt_abrogation && !pristineTexte.txt_abrogation) ? today : undefined"
					[firstDayOfWeek]="1"
					view="date"
					yearRange="1900:2100"
					[showIcon]="true"
					[showClear]="true"
					placeholder="{{'textes.abrogation_date_label' | translate}}"
					[required]="texte.txt_abrogation && !pristineTexte.txt_abrogation"
				></p-calendar>

			</div>

			<!-- Abrogation (booléen) -->
			<div class="field field-checkbox col-fixed">
				<!-- Si la case n'est pas cochée et qu'il y a une date dans le futur on empêche de cocher -->
				<p-checkbox
					name="txt_abrogation"
					[(ngModel)]="texte.txt_abrogation"
					[binary]="true"
					[readonly]="!editMode || (!texte.txt_abrogation && texte.txt_date_abrogation && texte.txt_date_abrogation > today)"
					[ngClass]="{inactive: editMode && !texte.txt_abrogation && texte.txt_date_abrogation && texte.txt_date_abrogation > today}"
					[label]="'textes.abrogation_label' | translate"
				></p-checkbox>
			</div>

			<div class="col-12"></div>

			<!-- Date application -->
			<div class="field col-12 md:col-6 xl:col-3">
				<label for="txt_date_application">
					{{ 'textes.application_date_label' | translate }}
				</label>

				<input
					*ngIf="!editMode"
					[ngClass]="{inactive: !texte.txt_date_application}"
					type="text"
					pInputText
					[attr.value]="texte.txt_date_application | date:'shortDate'"
					[readonly]="true"
				>

				<p-calendar
					*ngIf="editMode"
					name="txt_date_application"
					[(ngModel)]="texte.txt_date_application"
					dateFormat="dd/mm/yy"
					[firstDayOfWeek]="1"
					view="date"
					yearRange="1900:2100"
					[showIcon]="true"
					[showClear]="true"
					placeholder="{{'textes.application_date_label' | translate}}"
				></p-calendar>
			</div>

			<!-- Note d'applicaion -->
			<div class="field col-12 md:col-6 xl:col-3">
				<label for="txt_application">
					{{ 'textes.application_note_label' | translate }}
				</label>

				<input
					type="text"
					pInputText
					name="txt_application"
					[(ngModel)]="texte.txt_application"
					[readonly]="!editMode"
					placeholder="{{'textes.application_note_label' | translate}}"
				>
			</div>

			<div class="col-12"></div>

			<!-- Date modificative -->
			<div class="field col-12 md:col-6 xl:col-3">
				<label for="txt_date_modificative">
					{{ 'textes.modification_date_label' | translate }}
				</label>

				<input
					*ngIf="!editMode"
					[ngClass]="{inactive: !texte.txt_date_modificative}"
					type="text"
					pInputText
					[attr.value]="texte.txt_date_modificative | date:'shortDate'"
					[readonly]="true"
				>

				<p-calendar
					*ngIf="editMode"
					name="txt_date_modificative"
					[(ngModel)]="texte.txt_date_modificative"
					dateFormat="dd/mm/yy"
					[firstDayOfWeek]="1"
					view="date"
					yearRange="1900:2100"
					[showIcon]="true"
					[showClear]="true"
					placeholder="{{'textes.modification_date_label' | translate}}"
				></p-calendar>
			</div>

			<!-- Note sur la modification -->
			<div class="field col-12 md:col-6 xl:col-3">
				<label for="txt_modification">
					{{ 'textes.modification_note_label' | translate }}
				</label>

				<input
					type="text"
					pInputText
					name="txt_modification"
					[(ngModel)]="texte.txt_modification"
					[readonly]="!editMode"
					placeholder="{{'textes.modification_note_label' | translate}}"
				>
			</div>

			<div class="col-12"></div>

			<div class="field col-6 xxl:col-3">
				<label for="sta_code_defaut">
					{{ 'textes.defaut_recolement_status' | translate }}
				</label>

				<statut-recolement-selector
					name="sta_code_defaut"
					[(ngModel)]="texte.sta_code_defaut"
					[readonly]="!editMode"
					placeholder="{{'textes.defaut_recolement_status' | translate}}"
				></statut-recolement-selector>
			</div>

			<div class="col-12"></div>

			<!-- Exclusivement modificatif (booléen) -->
			<div class="field field-checkbox col-fixed">
				<p-checkbox
					name="txt_exclusivement_modificatif"
					[(ngModel)]="texte.txt_exclusivement_modificatif"
					(ngModelChange)="onModifExclusivenessChange()"
					[binary]="true"
					[readonly]="!editMode || !texte.txt_brouillon"
					[ngClass]="{inactive: !editMode || !texte.txt_brouillon}"
					[label]="'textes.exclusivement_modificatif_label' | translate"
				></p-checkbox>
			</div>

			<div class="col-12"></div>

			<!-- Intitulé (HTML) -->
			<div class="field col-12">
				<label for="txt_intitule" class="font-bold">
					{{ 'textes.intitule' | translate }}
				</label>

				<input
					*ngIf="!editMode && !texte.txt_intitule"
					type="text"
					pInputText
					[readonly]="true"
					class="block w-6 xxl:w-3"
				>

				<div *ngIf="editMode || texte.txt_intitule" class="w-full">
					<html-editor
						name="txt_intitule"
						[(ngModel)]="texte.txt_intitule"
						[readonly]="!editMode"
						class="mt-1"
						[ngClass]="!editMode ? 'no-padding-html-view no-border-html-view' : ''"
					></html-editor>
				</div>
			</div>

			<!-- Commentaire (HTML) -->
			<div class="field col-12">
				<label for="txt_commentaire" class="font-bold">
					{{ 'textes.commentaire_label' | translate }}
				</label>

				<input
					*ngIf="!editMode && !texte.txt_commentaire"
					type="text"
					pInputText
					[readonly]="true"
					class="block w-6 xxl:w-3"
				>

				<div *ngIf="editMode || texte.txt_intitule" class="w-full">
					<html-editor
						name="txt_commentaire"
						[(ngModel)]="texte.txt_commentaire"
						[readonly]="!editMode"
						class="mt-1"
						[ngClass]="!editMode ? 'no-padding-html-view no-border-html-view' : ''"
					></html-editor>
				</div>
			</div>
		</ng-container>

	
		<!-- Début section des articles -->
		<p-divider class="col-12" align="center">
			<b>{{'textes.articles_section_label' | translate}}<span *ngIf="texte.articles.length">({{texte.articles.length}})</span></b>
		</p-divider>

		<!-- Bouton d'ajout si aucun article -->
		<div *ngIf="texte.articles.length == 0" class="field col-12">
			<div class="w-full mb-2 font-bold">
				{{'textes.at_least_one_article_needed' | translate}}
			</div>

			<button
				type="button"
				pButton
				icon="pi pi-plus"
				class=""
				(click)="addArticle(0)"
				[label]="'textes.add_article' | translate"
				*ngIf="editMode"
			></button>
			<span *ngIf="!editMode">{{'textes.no_article_defined'|translate}}</span>
		</div>

		<!-- Recherche -->
		<div *ngIf="texte.articles.length" class="field col-fixed">
			<label for="search">{{'common.search_label'|translate}}</label>
			<div class="p-inputgroup mr-2">
				<input
					pInputText
					type="text"
					name="search"
					[(ngModel)]="search"
					(onDebounce)="onArticleSearchChange()"
					placeholder="{{'common.search_input_placeholder' | translate}}"
				/>
				<button type="button" class="p-inputgroup-addon" icon="pi pi-times" pButton label="" [disabled]="!search" (click)="search = null" ></button>
			</div>
		</div>

		<!-- Articles -->
		<div #articleScroller class="w-full">
			<p-table
				#dataViewArticles
				[value]="articles"
				[paginator]="true"
				paginatorPosition="top"
				[showCurrentPageReport]="true"
				[totalRecords]="articles.length"
				currentPageReportTemplate="{{articles.length | number}} élément(s)"
				[rows]="initialRowsPerPage"
				(rows)="currentRowsPerPage"
				[rowsPerPageOptions]="[5,10,25,50]"
				[scrollable]="true"
				responsiveLayout="scroll"
				scrollHeight="300"
				class="article-table"
			>
				<ng-template pTemplate="body" let-article let-index="rowIndex">
					<!-- Séparateur entre chaque article -->
					<div
						class="block col-12 mt-2 mb-2 flex flex-row align-items-center"
					>
						<div class="border-top-1 border-gray-100 flex-grow-1"></div>

						<!-- Bouton d'ajout d'article avant l'article courant -->
						<button
							*ngIf="editMode"
							type="button"
							pButton
							icon="pi pi-plus"
							class="p-button-rounded"
							(click)="addArticle(article.art_ordre)"
							[title]="'textes.add_article_here' | translate"
							[disabled]="search"
						></button>

						<div class="border-top-1 border-gray-100 flex-grow-1"></div>
					</div>

					<!-- Header (absent en mode lecture si titre vide) -->
					<div class="flex flex-row align-items-center w-full p-2 surface-ground border-round">
						<!-- Titre -->
						<div class="flex-grow-1 flex align-items-center">
							<span class="text-sm flex-shrink-0 mr-2">#{{article.art_ordre +1}}</span>
							<span *ngIf="!editMode" class="font-bold">
								{{article.art_titre}}
							</span>

							<input
								*ngIf="editMode"
								type="text"
								pInputText
								name="art_titre-{{article.art_id}}"
								[(ngModel)]="article.art_titre"
								[readonly]="!editMode"
								placeholder="{{'common.title_label' | translate}}"
								[required]="true"
							>
						</div>

						<div class="flex flex-row align-items-center mr-2">
							<!-- Abrogation article -->
							<div class="mb-0 ml-3">
								<!-- Si la case n'est pas cochée et qu'il y a une date dans le futur on empêche de cocher -->
								<p-checkbox
									name="article-abrogation{{article.art_id}}"
									[(ngModel)]="article.art_abrogation"
									[binary]="true"
									label="{{'textes.abrogation_label' | translate}}"
									[readonly]="!editMode || (!article.art_abrogation && article.art_date_abrogation && article.art_date_abrogation > today)"
									[ngClass]="{inactive: editMode && !article.art_abrogation && article.art_date_abrogation && article.art_date_abrogation > today}"
									[disabled]="!editMode"
								></p-checkbox>
							</div>

							<div class="ml-2 mr-2">
								<!-- Date d'abrogation de l'article -->
								<input
									*ngIf="!editMode && article.art_date_abrogation"
									class="surface-ground w-12rem"
									[ngClass]="{inactive: !article.art_date_abrogation}"
									type="text"
									pInputText
									[attr.value]="article.art_date_abrogation | date:'shortDate'"
									[readonly]="true"
								>

								<p-calendar
									*ngIf="editMode"
									[name]="'art_date_abrogation_' + article.art_id"
									[(ngModel)]="article.art_date_abrogation"
									(ngModelChange)="onDateAbrogationArticleChange(article)"
									dateFormat="dd/mm/yy"
									[maxDate]="(article.art_abrogation && !article.pristine.art_abrogation) ? today : undefined"
									[firstDayOfWeek]="1"
									view="date"
									yearRange="1900:2100"
									[showIcon]="true"
									[showClear]="true"
									placeholder="{{'textes.abrogation_date_label' | translate}}"
									appendTo="body"
								></p-calendar>
							</div>

							<!-- Article modificatif -->
							<div class="mb-0 ml-3">
								<p-checkbox
									name="article-modificatif{{article.art_id}}"
									[(ngModel)]="article.art_modificatif"
									[binary]="true"
									label="{{'textes.modificative' | translate}}"
									[disabled]="!editMode || texte.txt_exclusivement_modificatif || (!pristineTexte.txt_brouillon && !hasPristineTexteModificativeArticles)"
								></p-checkbox>
							</div>

							<!-- Modification majeure -->
							<div *ngIf="!texte.txt_brouillon" class="mb-0 ml-3">
								<p-checkbox
									name="article-modif-majeure{{article.art_id}}"
									[(ngModel)]="article.art_modification_majeure"
									[binary]="true"
									label="{{'textes.major_modification_label' | translate}}"
									[disabled]="!editMode"
								></p-checkbox>
							</div>

							<!-- Historique -->
							<button
								*ngIf="!isCreation"
								type="button"
								pButton
								class="p-button-rounded p-button-text p-button-sm ml-2"
								[label]="'common.history_button_label' | translate"
								icon="pi pi-book"
								(click)="showArticleHistoryDialog(article)"
							></button>

							<!-- Textes modifiants cet article -->
							<button
								*ngIf="modifsArticles[article.art_id] && modifsArticles[article.art_id].textes_modificatifs.length > 0"
								type="button"
								pButton
								class="p-button-rounded p-button-text p-button-sm ml-2"
								[label]="'textes.modificative_textes' | translate"
								icon="pi pi-book"
								(click)="showArticleModifyingTextesList(article, modifsArticles[article.art_id])"
							></button>

							<!-- Futures versions de l'article -->
							<button
								*ngIf="modifsArticles[article.art_id] && modifsArticles[article.art_id].versions_article.length > 0"
								type="button"
								pButton
								class="p-button-rounded p-button-text p-button-sm ml-2"
								[label]="'textes.future_versions' | translate"
								icon="pi pi-clock"
								(click)="showArticleFutureVersions(article, modifsArticles[article.art_id])"
							></button>
						</div>

						<!-- Boutons sur la droite -->
						<div class="flex flex-row">

							<!-- Réduction -->
							<button
								type="button"
								pButton
								icon="p-button-icon-left pi {{ expandedArticles[article.art_id]? 'pi-arrow-down-left-and-arrow-up-right-to-center' : 'pi-arrow-up-right-and-arrow-down-left-from-center' }}"
								class="p-button-rounded p-button-text"
								(click)="expandedArticles[article.art_id] = !!!expandedArticles[article.art_id]"
								[title]="(expandedArticles[article.art_id]? 'common.collapse': 'common.expand') | translate"
							>
							</button>

							<!-- Edition -->
							<button
								*ngIf="editMode"
								type="button"
								pButton
								icon="p-button-icon-left pi pi-pencil"
								class="p-button-rounded p-button-text"
								(click)="editArticle(article)"
								[title]="'textes.edit_article' | translate"
							>
							</button>
							<!-- Déplacement -->
							<button
								*ngIf="editMode"
								type="button"
								pButton
								icon="pi pi-sort-alt"
								class="p-button-rounded p-button-text"
								(click)="openArticleMoveDialog(article)"
								[title]="'textes.move_article_button_label' | translate"
								[disabled]="search"
							></button>

							<!-- Suppression -->
							<button
								*ngIf="editMode"
								type="button"
								pButton
								icon="pi pi-trash"
								class="p-button-rounded p-button-text"
								(click)="deleteArticle(article)"
								[title]="'common.delete' | translate"
								[disabled]="search"
							></button>
						</div>

					</div>

					<!-- Corps HTML -->
					<div class="html-content article-body w-full" 
						[ngClass]="{expanded: expandedArticles[article.art_id]}"
						(click)="expandedArticles[article.art_id] = true"
						[innerHTML]="article.art_corps">
					</div>

					<!-- Bouton d'ajout d'article fin de liste -->
					<div *ngIf="editMode && texte.articles.length && index == texte.articles.length - 1" 
						class="block col-12 flex flex-row align-items-center">
						<div class="border-top-1 border-gray-100 flex-grow-1"></div>
						<button
							type="button"
							pButton
							icon="pi pi-plus"
							class="p-button-rounded"
							(click)="addArticle(texte.articles.length)"
							[title]="'textes.add_article_here' | translate"
							[disabled]="search"
						></button>
						<div class="border-top-1 border-gray-100 flex-grow-1"></div>
					</div>
				</ng-template>
			</p-table>
		</div>

		<!-- Section des opérations modificatives -->
		<div *ngIf="texte.operations_modificatives.length > 0 || (editMode && (pristineTexte.txt_brouillon || hasPristineTexteModificativeArticles))" class="w-full mb-3">
			<p-divider class="col-12" align="center">
				<b>{{'textes.operations_section_label' | translate}}</b>
			</p-divider>

			<operations-section
				class="col-12 block"
				name="operations"
				[(ngModel)]="texte.operations_modificatives"
				[readonly]="!editMode"
				[required]="false"
			></operations-section>
		</div>
	</form>

</p-panel>
